import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

// Icons
import facebookSvg from 'assets/icons/facebook.svg'
import instagramSvg from 'assets/icons/instagram.svg'
import inboxSvg from 'assets/icons/inbox.svg'
import buildSvg from 'assets/icons/build.svg'
import profileSvg from 'assets/icons/profile.svg'
import shareSvg from 'assets/icons/share.svg'
import twitterSvg from 'assets/icons/twitter.svg'
import linkedinSvg from 'assets/icons/linkedin.svg'
import linkSvg from 'assets/icons/link.svg'
import zapSvg from 'assets/icons/zap.svg'
import plusCirleSvg from 'assets/icons/plus-circle.svg'
import helpCenterSvg from 'assets/icons/help-center.svg'

export const FacebookIcon = props => (
  <SvgIcon {...props}>
    <use xlinkHref={`#${facebookSvg.id}`} />
  </SvgIcon>
)

export const InstagramIcon = props => (
  <SvgIcon {...props}>
    <use xlinkHref={`#${instagramSvg.id}`} />
  </SvgIcon>
)

export const InboxIcon = props => (
  <SvgIcon {...props}>
    <use xlinkHref={`#${inboxSvg.id}`} />
  </SvgIcon>
)

export const BuildIcon = props => (
  <SvgIcon {...props}>
    <use xlinkHref={`#${buildSvg.id}`} />
  </SvgIcon>
)

export const ProfileIcon = props => (
  <SvgIcon {...props}>
    <use xlinkHref={`#${profileSvg.id}`} />
  </SvgIcon>
)

export const ShareIcon = props => (
  <SvgIcon {...props}>
    <use xlinkHref={`#${shareSvg.id}`} />
  </SvgIcon>
)

export const TwitterIcon = props => (
  <SvgIcon {...props}>
    <use xlinkHref={`#${twitterSvg.id}`} />
  </SvgIcon>
)

export const LinkedInIcon = props => (
  <SvgIcon {...props}>
    <use xlinkHref={`#${linkedinSvg.id}`} />
  </SvgIcon>
)

export const LinkIcon = props => (
  <SvgIcon {...props}>
    <use xlinkHref={`#${linkSvg.id}`} />
  </SvgIcon>
)

export const ZapIcon = props => (
  <SvgIcon {...props}>
    <use xlinkHref={`#${zapSvg.id}`} />
  </SvgIcon>
)

export const PlusCirleIcon = props => (
  <SvgIcon {...props}>
    <use xlinkHref={`#${plusCirleSvg.id}`} />
  </SvgIcon>
)

export const HelpCenterIcon = props => (
  <SvgIcon {...props}>
    <use xlinkHref={`#${helpCenterSvg.id}`} />
  </SvgIcon>
)
